<template>
  <div class="early-checkin-view">
    <div class="cnt-content m-b-10">
      <el-row :gutter="20">
        <el-col :span="12">
          <span class="form-label">订单编号：</span>
          <span>{{ formData.orderCode }}</span>
        </el-col>
        <el-col :span="12">
          <span class="form-label">房型：</span>
          <span>{{ formData.roomCode }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <span class="form-label">房源名称：</span>
          <span>{{ formData.roomName }}</span>
        </el-col>
      </el-row>
    </div>
    <div class="cnt-content highlight m-b-10">
      <el-row class="m-b-15" :gutter="20">
        <el-col :span="24">
          <span>总制卡数：</span>
          <span>{{ formData.cardTotal }}</span>
        </el-col>
      </el-row>
      <el-form inline :model="form" ref="form"
        :rules="rules"
      >
        <el-form-item label="持卡人" prop="id">
          <el-select v-model="form.id">
            <el-option
              :value="e.id"
              :label="e.personName"
              v-for="(e, i) of formData.checkInPersonInfoDTOS"
              :key="i"
              :disabled="e.holdCard"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡号" prop="unlockPassword">
          <el-input placeholder="请读取或输入IC卡号" v-model="form.unlockPassword"></el-input>
        </el-form-item>
      </el-form>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="flex">
            <span>房卡有效期：</span>
            <span>{{formData.proposedCheckOutTime}}:00</span>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="bottom-btn">
      <el-button class="submit-btn" :loading="saveLoading" @click="handleConfirm">制卡</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Moment from 'moment'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {
        id: [{required: true,  message: '请选择持卡人',}],
        unlockPassword: [
          {required: true, message: '请输入卡号',},
          {
            validator: (rule, value, cb) => {
              if(!/^[0-9a-fA-F]+$/.test(value)) return cb(new Error('卡号仅支持16进制数(大写字母)'));
              cb();
            },
            trigger: 'change',
          }
        ],
      },
      form: {
        id: "",
        unlockPassword: "",
      },
      isEditPrice: false,
      saveLoading: false,

      newOrderPrice: 0,
      newProposedCheckInTime: '',
    }
  },
  created() {
    this.initFormData()
  },
  watch: {
    show(val) {
      if (val) {
        this.initFormData()
      }
    }
  },
  methods: {
    ...mapActions([ 'fetchData' ]),
    // 获取禁用日期时间
    getDisabledDate(date) {
      let day = date.getDate()
      let proDate = new Date(this.formData.proposedCheckInTime)
      let preProDate = new Date((+proDate) - 24 * 60 * 60 * 1000)
      if (day === proDate.getDate() || day === preProDate.getDate()) {
        return false
      }

      return true
    },
    // 初始化数据
    initFormData() {
      this.isEditPrice = false
      this.newOrderPrice = this.formData.orderPrice || 0
      this.newProposedCheckInTime = this.formData.proposedCheckInTime
    },
    // 处理确认
    async handleConfirm() {
      await this.$refs.form.validate()
      this.saveLoading = true
      const order = this.formData;
      const person = order.checkInPersonInfoDTOS.find(e => e.id == this.form.id);
      this.fetchData({
        url: 'SAAS.ORDERINFO_MAKEDOORCARD',
        method: 'post',
        params: {
          deviceCode: order.deviceCode,
          authName: person.personName,
          idNumber: person.certificateNumber,
          identification: person.id,
          phone: person.personPhone,
          startTime: (order.actualCheckInTime || order.proposedCheckInTime) + ':00',
          endTime: order.proposedCheckOutTime+':00',
          passwordType: 2,
          unlockPassword: this.form.unlockPassword,
        },
        flag: true,
        headers: { 'Content-Type': 'application/json' }
      }).then(res => {
        if (res.code === 200) {
          if(res.data){
            this.$message.success('制卡成功，请到达门前唤醒门锁更新授权信息！')
          }else{
            this.$message.error('该入住人已持有卡，无需重复制卡！')
          }
          this.$emit('success')
        } else {
          this.$message.error(res.msg || '操作失败！')
        }
      }).catch(err => {
        this.$message.error(err || '操作失败！')
      }).finally(() => {
        this.saveLoading = false
      })
    },
    // 处理取消
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.early-checkin-view {
  color: black;
}
.cnt-top-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .cnt-title {
    font-size: 18px;
    color: #333;
  }
  .title-extra {
    span {
      margin-left: 10px;
    }
    .span-phone {
      color: rgb(55, 146, 215);
    }
  }
}
.form-label {
  color: #959697;
}
.cnt-content {
  padding: 15px 20px;
  background-color: rgb(245, 245, 245);
  border-radius: 3px;
  &.highlight {
    background-color: rgb(241, 250, 255);
  }
}
.font-price {
  font-size: 24px;
  font-weight: bold;
  color: rgb(235, 66, 66);
}
.font-btn-blue {
  color: rgb(0, 192, 192);
}
.bottom-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 10px;
  width: 100%;
}
.flex {
  display: flex;
  align-items: center;
}
</style>